export const CURRENCIES = [
    "MXN",
    "USD",
    "EUR"
];
